import { Link } from "react-router-dom";
import DropdownMenu from "../DropdownMenu/DropdownMenu";

type HighlightType = "indigo" | "red" | null;

interface WorkoutCardProps {
  id: string;
  title: string;
  date: string;
  className?: string;
  highlightType?: HighlightType;
  onEditWorkout: (id: string) => void;
  onRepeatWorkout: (id: string) => void;
  onDeleteWorkout: (id: string) => void;
  onAddToProgram: (id: string) => void;
}

const DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  weekday: "short",
  year: "numeric",
  month: "long",
  day: "numeric",
};

const BASE_LINK_CLASSES =
  "grid grid-cols-[1fr_auto] content-center p-2 pr-7 rounded-md shadow-sm mb-1 border border-gray-300 transition-colors duration-500 ease-out";

const HIGHLIGHT_CLASSES: Record<NonNullable<HighlightType>, string> = {
  indigo:
    "bg-gradient-to-r from-white via-indigo-100 to-white bg-[length:200%_100%] animate-[gradient-sweep_0.6s_ease-out_forwards] border-indigo-300",
  red: "bg-gradient-to-r from-white via-red-100 to-white bg-[length:200%_100%] animate-[gradient-sweep_0.6s_ease-out_forwards] border-red-300",
};

const WorkoutCard: React.FC<WorkoutCardProps> = ({
  id,
  title,
  date,
  className,
  highlightType = null,
  onEditWorkout,
  onRepeatWorkout,
  onDeleteWorkout,
  onAddToProgram,
}) => {
  const formattedDate = new Date(date).toLocaleDateString(
    "en-US",
    DATE_FORMAT_OPTIONS,
  );

  return (
    <div className={`relative ${className ?? ""}`}>
      <Link
        to={`workout/${id}`}
        state={{ workoutTitle: title, workoutDate: date }}
        className={`${BASE_LINK_CLASSES} ${
          highlightType
            ? HIGHLIGHT_CLASSES[highlightType]
            : "bg-white border-gray-300"
        }`}
      >
        <div className="overflow-hidden">
          <h3 className="text-base font-medium text-gray-900 w-full whitespace-nowrap overflow-hidden text-ellipsis">
            {title}
          </h3>
          <p className="text-sm text-gray-500">{formattedDate}</p>
        </div>
      </Link>
      <div className="absolute top-0 right-0">
        <DropdownMenu
          menuItems={["Edit", "Repeat", "Add to Program", "Delete"]}
          parentId={id}
          onEditClicked={onEditWorkout}
          onRepeatClicked={onRepeatWorkout}
          onAddToProgramClicked={onAddToProgram}
          onDeleteClicked={onDeleteWorkout}
        />
      </div>
    </div>
  );
};

export default WorkoutCard;
